import { render, staticRenderFns } from "./InputSelectTag.vue?vue&type=template&id=4a4e39c6"
import script from "./InputSelectTag.vue?vue&type=script&lang=js"
export * from "./InputSelectTag.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./InputSelectTag.vue?vue&type=style&index=1&id=4a4e39c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports